import React, { CSSProperties, useCallback, useEffect, useState } from 'react'
import { sleep } from 'utils/general'
import { SFakeProgressBar, SFilledBar } from './FakeProgressBar.styled'

const FakeProgressBar = ({
  percentage,
  duration,
  style,
  filledStyle,
  reset,
}: {
  percentage: number
  duration: number
  style?: CSSProperties
  filledStyle?: CSSProperties
  reset: () => void
}) => {
  useEffect(() => {
    return () => {
      reset()
    }
  }, [reset])
  return (
    <SFakeProgressBar style={style}>
      <SFilledBar percentage={percentage} duration={duration} style={filledStyle} />
    </SFakeProgressBar>
  )
}

export const useFakeProgressBar = (props?: {
  style?: CSSProperties
  filledStyle?: CSSProperties
  initialPercentage?: number
}) => {
  const [progressBarStatus, setProgressBarStatus] = useState({
    percentage: props?.initialPercentage || 0,
    duration: 1000,
  })

  const progress = useCallback(async (percentage: number, duration: number) => {
    await sleep(100)
    setProgressBarStatus({
      percentage,
      duration,
    })
    return sleep(duration)
  }, [])

  const reset = useCallback(
    () =>
      setProgressBarStatus({
        percentage: 0,
        duration: 1000,
      }),
    []
  )

  const fakeProgressBar = (
    <FakeProgressBar
      percentage={progressBarStatus.percentage}
      duration={progressBarStatus.duration}
      reset={reset}
      style={props?.style}
      filledStyle={props?.filledStyle}
    />
  )

  return [fakeProgressBar, progress] as const
}
